import api from '../config/axiosConfig';
import { 
  Sale, 
  SaleCreate, 
  SaleListItem, 
  VoidSaleRequest, 
  VoidSaleResponse,
  DiscountEligibilityRequest,
  DiscountEligibilityResponse,
  PaymentMethod,
  SaleStatus
} from '../types/sale';
import { API_BASE_URL } from '../utils/constants';

const API_URL = `${API_BASE_URL}/sales`;

export const checkDiscountEligibility = async (
  request: DiscountEligibilityRequest
): Promise<DiscountEligibilityResponse> => {
  const response = await api.post<DiscountEligibilityResponse>(
    `${API_URL}/check-discount`,
    request
  );
  return response.data;
};

export const createSale = async (saleData: SaleCreate): Promise<Sale> => {
  console.log('🚀 saleService.createSale - Request body:', JSON.stringify(saleData, null, 2));
  
  try {
    const response = await api.post<Sale>(API_URL, saleData);
    
    // Check if response is actually an error (in case axios config treats it as success)
    const data = response.data as any;
    if (data && (data.detail || data.message) && !data.id) {
      // This is an error response, not a successful sale
      console.error('❌ saleService.createSale - Validation Error:', data);
      throw {
        response: {
          status: 422,
          data: data
        },
        message: data.message || 'Validation failed'
      };
    }
    
    console.log('✅ saleService.createSale - Success:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('❌ saleService.createSale - Error:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      code: error.code
    });
    throw error;
  }
};

export const createSaleForBranch = async (
  branchId: number,
  saleData: SaleCreate
): Promise<Sale> => {
  console.log('🚀 saleService.createSaleForBranch - Branch:', branchId, 'Data:', JSON.stringify(saleData, null, 2));
  
  try {
    const response = await api.post<Sale>(
      `${API_URL}/branch/${branchId}`,
      saleData
    );
    console.log('✅ Sale created for branch:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('❌ createSaleForBranch - Error:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      code: error.code
    });
    throw error;
  }
};

export const getSales = async (params?: {
  branch_id?: number;
  start_date?: string;
  end_date?: string;
  payment_method?: PaymentMethod;
  status?: SaleStatus;
  page?: number;
  page_size?: number;
}): Promise<SaleListItem[]> => {
  const response = await api.get<SaleListItem[]>(API_URL, { params });
  return response.data;
};

// Alias for reports page
export const fetchSalesReport = getSales;

export const getSaleById = async (id: number): Promise<Sale> => {
  const response = await api.get<Sale>(`${API_URL}/${id}`);
  return response.data;
};

export const voidSale = async (
  id: number,
  request: VoidSaleRequest
): Promise<VoidSaleResponse> => {
  const response = await api.post<VoidSaleResponse>(
    `${API_URL}/${id}/void`,
    request
  );
  return response.data;
};

export const getReceipt = async (id: number): Promise<any> => {
  const response = await api.get(`${API_URL}/${id}/receipt`);
  return response.data;
};

export const printReceipt = async (id: number): Promise<Blob> => {
  const response = await api.get(`${API_URL}/${id}/receipt/print`, {
    responseType: 'blob',
  });
  return response.data;
};
